module.exports = __webpack_public_path__ + "ad32e78d11c44546a926c50b6b58749c.svg";